import { AvatarGroup } from '@mui/material';
import { forwardRef } from 'react';

//
import type { CustomAvatarGroupProps } from './types';

// ----------------------------------------------------------------------

const SIZES = {
  large: 56,
  medium: 40,
  small: 32,
  tiny: 24,
};

const CustomAvatarGroup = forwardRef<HTMLDivElement, CustomAvatarGroupProps>(
  ({ children, compact, max, size = 'small', sx, ...other }, ref) => {
    const isTiny = size === 'tiny';

    const isSmall = size === 'small';

    const isMedium = size === 'medium';

    const isLarge = size === 'large';

    const compactStyle = {
      '& .MuiAvatarGroup-avatar': {
        '&:first-of-type': {
          bottom: 0,
          left: 0,
          zIndex: 9,
        },
        '&:last-of-type': {
          right: 0,
          top: 0,
        },
        height: 28,
        m: 0,
        position: 'absolute',
        width: 28,
      },
      height: 40,
      position: 'relative',
      width: 40,
    } as const;

    return (
      <AvatarGroup
        max={compact ? 3 : max}
        ref={ref}
        spacing={((isTiny || isSmall) && 'medium') || 'small'}
        sx={{
          '& .MuiAvatar-root': {
            ...(isLarge && {
              '&:first-of-type': { fontSize: 16 },
              height: SIZES.large,
              width: SIZES.large,
            }),
            ...(isMedium && {
              height: SIZES.medium,
              width: SIZES.medium,
            }),
            ...(isSmall && {
              height: SIZES.small,
              width: SIZES.small,
            }),
            ...(isTiny && {
              height: SIZES.tiny,
              width: SIZES.tiny,
            }),
          },
          ...(compact && { ...compactStyle }),
          ...sx,
        }}
        {...other}
      >
        {children}
      </AvatarGroup>
    );
  }
);

CustomAvatarGroup.displayName = 'CustomAvatarGroup';

export default CustomAvatarGroup;
